import script from "./esMedicalPersonForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./esMedicalPersonForm.vue?vue&type=script&setup=true&lang=ts"

import "./esMedicalPersonForm.vue?vue&type=style&index=0&id=4d4e80ed&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d4e80ed"]])

export default __exports__